import axios from 'axios';

function apply_scheduling_auth(target) {
    target.interceptors.request.use(
        config => {
            config.headers['Authorization'] = `Bearer ${window.auth_token || 'dummy_token'}`;
            return config;
        },
        error => {
            Promise.reject(error);
        }
    );
    return target;
}

function handle_response(response) {
    return response.data;
}

let baseURL = process.env.REACT_APP_MODE_SCHEDULER_API_URL || 'http://localhost:8000/';
const client = apply_scheduling_auth(axios.create({ baseURL }));

export async function get_operational_modes() {
    return client.get('/modes').then(handle_response);
}

export async function get_device_schedule(deviceId) {
    return client.get(`/devices/${deviceId}/schedule`); // no handle response, expected logic if 404
}

export async function setup_device_weekly_schedule(device_id) {
    return client.post(`/devices/${device_id}/scheduler-setup`).then(handle_response);
}

export async function update_daily_blueprint(blueprint_id, slots, name = 'updated') {
    return client
        .put(`/blueprints/daily/${blueprint_id}`, {
            name,
            slots,
        })
        .then(handle_response);
}

export async function get_device_daily_bp_configs(device_id, daily_bp_id) {
    return client.get(`/blueprints/daily/${daily_bp_id}/configs/${device_id}`).then(handle_response);
}

export async function post_device_daily_mode_config(device_id, daily_bp_id, configs) {
    return client.post(`/blueprints/daily/${daily_bp_id}/configs/${device_id}`, configs).then(handle_response);
}

export async function update_device_daily_mode_config(device_id, daily_bp_id, config_id, config) {
    return client.put(`/blueprints/daily/${daily_bp_id}/configs/${device_id}/${config_id}`, config).then(handle_response);
}

export async function delete_device_daily_mode_config(device_id, daily_bp_id, config_id) {
    return client.delete(`/blueprints/daily/${daily_bp_id}/configs/${device_id}/${config_id}`).then(handle_response);
}

const exportedObject = {
    get_operational_modes,
    get_device_schedule,
    setup_device_weekly_schedule,
    update_daily_blueprint,
    get_device_daily_bp_configs,
    post_device_daily_mode_config,
    update_device_daily_mode_config,
    delete_device_daily_mode_config,
};
export default exportedObject;
